import DataBinder from "../DataBinder.js";
import SwapPage from "../SwapPage.js";

export default class FindServerContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "FindServer";
  }

  async show(path, model = {}) {
    const pageId = this.pageId;
    const app = this.app;
    const userdata = app.userdata;



    app.populate(pageId, model);
    app.swapPage(pageId);

    let isLoggedIn = userdata && userdata.id;
    if (!isLoggedIn) {
      if (app.portal && app.portal.autoLogin) {
          await app.autoLogin();
      } else {
        app.navigate("Login");
        return;
      }
    }

    this.connect(app.userdata);
  }
  connect(userdata) {
    const app = this.app;
    let serverUrl = userdata.serverUrl;
    app.gameServer.connectAsync(userdata, serverUrl)
      .then(function () {
        app.navigate("Online");
      }.bind(this))
      .catch(function (err) {
        app.navigate("MainMenu");
        app.createNotification("Failed to connect to server");
      }.bind(this));
  }
}
